import DefinitionBracket from './DefinitionBracket.vue'
import DefinitionNode from './DefinitionNode.vue'
import DefinitionOperator from './DefinitionOperator.vue'
import DefinitionNodeDropZone from './DefinitionNodeDropZone.vue'

export default {
  functional: true,
  props: {
    definition: {
      type: Array,
      required: true
    },
    enableDragAndDrop: {
      type: Boolean,
      default: false
    },
    enableNot: {
      type: Boolean,
      default: true
    },
    isDraggingPart: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  render (h, context) {
    let p = context.props
    const renderThis = flattenedDefinitionComponents(
      h,
      p.definition,
      p.enableDragAndDrop,
      p.disabled,
      p.enableNot
    )
    if (p.enableDragAndDrop && p.isDraggingPart) {
      renderThis.push(h(DefinitionNodeDropZone))
    }
    return h('div', {
      attrs: {
        id: 'target-definition-statement',
        class: 'target-definition-statement'
      },
      style: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center'
      }
    }, renderThis)
  }
}

function flattenedDefinitionComponents (h, definition, enableDragAndDrop, disabled, enableNot) {
  let level = 0
  const reducer = (acc, attr, index, arr) => {
    if (attr.type || attr.id && attr.value) {
      acc.push(
        h(DefinitionNode, {
          props: {
            definitionId: attr.definitionId,
            attribute: attr,
            inGroup: level > 0,
            isFirst: index === 0,
            isLast: index === arr.length - 1,
            isDraggable: enableDragAndDrop,
            disabled,
            level
          }
        })
      )
    }

    if (attr.children) {
      level++
      const isSuperGroup = attr.children.filter(a => a.children).length
      // add left bracket
      acc.push(isSuperGroup ? createBracketIcon(h, {
        definitionId: attr.definitionId,
        direction: DefinitionBracket.DIRECTION.left,
        bracketType: DefinitionBracket.BRACKET_TYPE.square,
        attribute: attr,
        isDraggable: enableDragAndDrop,
        disabled,
        level
      }) : createBracketIcon(h, {
        definitionId: attr.definitionId,
        direction: DefinitionBracket.DIRECTION.left,
        isDraggable: enableDragAndDrop,
        attribute: attr,
        disabled,
        level
      }))
      // build group children
      acc.concat(attr.children.reduce(reducer, acc))
      // add right bracket
      acc.push(isSuperGroup ? createBracketIcon(h, {
        definitionId: attr.definitionId,
        direction: DefinitionBracket.DIRECTION.right,
        bracketType: DefinitionBracket.BRACKET_TYPE.square,
        attribute: attr,
        isDraggable: enableDragAndDrop,
        disabled,
        level
      }) : createBracketIcon(h, {
        definitionId: attr.definitionId,
        direction: DefinitionBracket.DIRECTION.right,
        attribute: attr,
        isDraggable: enableDragAndDrop,
        disabled,
        level
      }))
      level--
    }

    if (attr.operator) {
      acc.push(h(DefinitionOperator, {
        props: {
          definitionId: attr.definitionId,
          operator: attr,
          isDraggable: enableDragAndDrop,
          disabled,
          level,
          enableNot
        }
      }))
    }

    return acc
  }
  return definition.reduce(reducer, [])
}

function createBracketIcon (h, {definitionId, direction, bracketType = DefinitionBracket.BRACKET_TYPE.normal, attribute, isDraggable, disabled, level}) {
  return h(DefinitionBracket, {
    props: {
      definitionId,
      direction,
      bracketType,
      attribute,
      isDraggable,
      disabled,
      level
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/appComponents/workbench/targetDefinition/components/targetDefinitionStatement/index.js